import styled from '@emotion/styled';
import media from '@shared/mediaQuery';

const SolutionStyle = styled('div')`
  padding-bottom: 80px;
  .solution-products-wrapper {
    ${media.mobile} {
      margin-top: 16px;
    }
  }
  .solution-advantage-wrapper {
    ${media.mobile} {
      margin-top: 91px;
    }
    ${media.desktop} {
      margin-top: 120px;
    }
  }
  .solution-process-wrapper {
    margin-top: 100px;
  }
  .solutioncomp {
    &--subtitle {
      font-size: 16px;
      font-family: 'Gilroy-ExtraBold';
      color: #ff5500;
      ${media.desktop} {
        font-size: 18px;
      }
    }
    &--title {
      font-size: 24px;
      font-family: 'Pretendard-Bold';
      color: #333333;
      margin-top: 2px;
      ${media.desktop} {
        font-size: 28px;
        margin-top: 4px;
      }
    }
  }
`;

export default SolutionStyle;
